import angular from 'angular';
import moment from 'moment';

import templateUrl from './icd-corporation-payout-policy-list.component.html'

export const IcdCorporationPayoutPolicyListComponent = {
    controller: IcdCorporationPayoutPolicyListController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        icdCorporationPayoutPolicies: "<",
        icdCorporations: "<",
        createIcdPayoutPolicy: "<onCreate",
        updateIcdPayoutPolicy: "<onUpdate",
        deleteIcdPayoutPolicy: "<onDelete"
    }
}

function IcdCorporationPayoutPolicyListController($uibModal, utilityService) {
    'ngInject';
    const vm = this;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;

    vm.icdCorporationPayoutPolicies;
    vm.icdCorporations;
    vm.createIcdPayoutPolicy;
    vm.updateIcdPayoutPolicy;
    vm.deleteIcdPayoutPolicy;
    vm.filters = { ActiveOn: moment().startOf('day').toDate() };
    vm.filterIcdCorporationPayoutPolicy = filterIcdCorporationPayoutPolicy;
    vm.onEdit = onEdit;

    function onInit() {

    }

    function onChanges(changes) {

    }

    function onEdit(icdPayoutPolicy) {
        const isNew = !icdPayoutPolicy;
        icdPayoutPolicy = icdPayoutPolicy || { PayoutPolicies: [], RepPayoutPolicies: [] };

        $uibModal.open({
            component: "apexEditIcdCorporationPayoutPolicyModal",
            resolve: {
                icdCorporationPayoutPolicy: function () {
                    return angular.copy(icdPayoutPolicy);
                },
                icdCorporations: function () {
                    return vm.icdCorporations;
                },
                save: function () {
                    return isNew ? onCreate : onUpdate;
                }
            },
            windowClass: 'xx-dialog pagespinner',
            size: 'lg',
            backdrop: 'static'
        });
    }

    function onCreate(policy) {
        return vm.createIcdPayoutPolicy(policy);
    }

    function onUpdate(policy) {
        return vm.updateIcdPayoutPolicy(policy);
    }

    function filterIcdCorporationPayoutPolicy(icdPayoutPolicy) {
        const filters = vm.filters;
        const icd = icdPayoutPolicy.IcdCorporation;

        let res;

        if (filters.ActiveOn) {
            // If filtering by Active On date, start by excluding all policies except those
            // active on the given date.
            res = false;

            const activePayoutPolicy = icdPayoutPolicy.ActivePayoutPolicy;
            const activeRepPayoutPolicy = icdPayoutPolicy.ActiveRepPayoutPolicy;

            // Include as long as one of the two active payout policies are active on the date.
            if (activePayoutPolicy) {
                res = res || (!activePayoutPolicy.ActiveStart || activePayoutPolicy.ActiveStart <= filters.ActiveOn)
                    && (!activePayoutPolicy.ActiveEnd || filters.ActiveOn <= activePayoutPolicy.ActiveEnd);
            }

            if (activeRepPayoutPolicy) {
                res = res || (!activeRepPayoutPolicy.ActiveStart
                    || activeRepPayoutPolicy.ActiveStart <= filters.ActiveOn)
                    && (!activeRepPayoutPolicy.ActiveEnd || filters.ActiveOn <= activeRepPayoutPolicy.ActiveEnd);
            }
        } else {
            // Otherwise, include all by default and filter only by text.
            res = true;
        }

        res = res && (!filters.ClientName || utilityService.containsInvariant(icd.ClientName, filters.ClientName))
            && (!filters.Owner || utilityService.containsInvariant(icd.Owner, filters.Owner));

        return res;
    }
}
